import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';
import { normalizeBaseFamilyFoldersItem, normalizeFamilyContentAlbumItem } from 'reactApp/modules/familyContent/familyContent.helpers';
import {
    type ChangeFamilyContentCategoryAction,
    type FamilyAlbumsLoadSuccessAction,
    type FamilyContentLoadRequestAction,
    type FamilyContentState,
    type FamilyFoldersLoadSuccessAction,
    FamilyContentCategoryType,
} from 'reactApp/modules/familyContent/familyContent.types';

import { EStorageType } from '../storage/storage.types';

const initialState: FamilyContentState = {
    categories: [
        {
            name: 'Папки',
            id: FamilyContentCategoryType.folders,
            value: FamilyContentCategoryType.folders,
            childs: [],
            isLoaded: false,
            isLoading: false,
        },
        {
            name: 'Альбомы',
            id: FamilyContentCategoryType.albums,
            value: FamilyContentCategoryType.albums,
            childs: [],
            isLoaded: false,
            isLoading: false,
        },
    ],
    currentCategory: FamilyContentCategoryType.folders,
    list: {},
};

export const familyContentLoadRequest = createAction<undefined | FamilyContentLoadRequestAction>('familyContent/loadContent');
export const familyContentLoadStart = createAction<FamilyContentLoadRequestAction>('familyContent/loadStart');
export const familyFoldersLoadSuccess = createAction<FamilyContentLoadRequestAction>('familyContent/foldersLoadSuccess');
export const familyAlbumsLoadSuccess = createAction<FamilyContentLoadRequestAction>('familyContent/albumsLoadSuccess');
export const changeFamilyContentCategory = createAction<ChangeFamilyContentCategoryAction>('familyContent/changeCategory');

export const familyContentReducer = createReducer(initialState, {
    [familyContentLoadStart.type]: (state, action: PayloadAction<FamilyContentLoadRequestAction>) => {
        state.currentCategory = action.payload.category;
        const category = state.categories.find((category) => category.id === action.payload.category);

        if (category) {
            category.childs = [];
            category.isLoaded = false;
            category.isLoading = true;
        }
    },
    [familyFoldersLoadSuccess.type]: (state, action: PayloadAction<FamilyFoldersLoadSuccessAction>) => {
        const category = state.categories.find((category) => category.id === action.payload.category);
        const list = state.list;

        if (!category) {
            return;
        }

        const data = action.payload.data;

        if (!data?.list) {
            category.isLoaded = true;
            category.isLoading = false;
            return;
        }

        for (const item of data.list) {
            list[item.home] = { ...normalizeBaseFamilyFoldersItem(item), storage: EStorageType.familyFolders };
            category.childs.push(item.home);
        }

        category.isLoaded = true;
        category.isLoading = false;
    },
    [familyAlbumsLoadSuccess.type]: (state, action: PayloadAction<FamilyAlbumsLoadSuccessAction>) => {
        const category = state.categories.find((category) => category.id === action.payload.category);
        const list = state.list;

        if (!category) {
            return;
        }

        const data = action.payload.data;

        if (!data?.list) {
            category.isLoaded = true;
            category.isLoading = false;
            return;
        }

        if (category?.childs.length) {
            category.childs = [];
        }

        for (const item of data.list) {
            list[item.id] = { ...normalizeFamilyContentAlbumItem(item), storage: EStorageType.familyAlbums };
            category.childs.push(item.id);
        }

        category.isLoaded = true;
        category.isLoading = false;
    },
    [changeFamilyContentCategory.type]: (state, action: PayloadAction<ChangeFamilyContentCategoryAction>) => {
        state.currentCategory = action.payload.category;

        const category = state.categories.find((category) => category.id === action.payload.category);

        if (category) {
            category.isLoaded = false;
            category.isLoading = true;
        }
    },
});
